import React from "react";
import { Drawer } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { setShapesDrawer } from "./../../slices/creatorSlice";
import {
  addCircle,
  addRectangle,
  addTriangle,
  addPolygone,
  addLine,
} from "../../CommonFunctions/PropertybarFunctions";
import CircleImg from "../../CommonFunctions/shapesImg/Circle.png";
import RectangleImg from "../../CommonFunctions/shapesImg/Rect.png";
import TriangleImg from "../../CommonFunctions/shapesImg/Triangle.png";
import TrapzoidImg from "../../CommonFunctions/shapesImg/Trapzoid.png";
import HexagoneImg from "../../CommonFunctions/shapesImg/Hexagone.png";
import Star4Img from "../../CommonFunctions/shapesImg/star4.png";
import Star5Img from "../../CommonFunctions/shapesImg/star5.png";
import LineImg from "../../CommonFunctions/shapesImg/Line.png";
const ShapesDrawer = ({ canvas }) => {
  const visible = useSelector((state) => state.creator.shapesDrawerOpen);
  const dispatch = useDispatch();
  return (
    <Drawer
      title="Shapes"
      placement={"left"}
      closable={true}
      onClose={() => {
        dispatch(setShapesDrawer(!visible));
      }}
      visible={visible}
      key={"left"}
    >
      <div className="grid grid-cols-2 gap-1 w-full">
        <div
          className="flex justify-center items-center p-2"
          onClick={(e) => {
            e.preventDefault();
            addCircle(canvas);
          }}
        >
          <img src={CircleImg} alt="Circle" className="w-full h-full" />
        </div>
        <div
          className="flex justify-center items-center p-2"
          onClick={(e) => {
            e.preventDefault();
            addRectangle(canvas);
          }}
        >
          <img src={RectangleImg} alt="Rectangle" className="w-full h-full" />
        </div>
        <div
          className="flex justify-center items-center p-2"
          onClick={(e) => {
            e.preventDefault();
            addTriangle(canvas);
          }}
        >
          <img src={TriangleImg} alt="Triangle" className="w-full h-full" />
        </div>
        <div
          className="flex justify-center items-center p-2"
          onClick={(e) => {
            e.preventDefault();
            addPolygone(canvas, "trapzoid");
          }}
        >
          <img src={TrapzoidImg} alt="Trapzoid" className="w-full h-full" />
        </div>
        <div
          className="flex justify-center items-center p-2"
          onClick={(e) => {
            e.preventDefault();
            addPolygone(canvas, "hexagone");
          }}
        >
          <img src={HexagoneImg} alt="Hexagone" className="w-full h-full" />
        </div>
        <div
          className="flex justify-center items-center p-2"
          onClick={(e) => {
            e.preventDefault();
            addPolygone(canvas, "star4");
          }}
        >
          <img src={Star4Img} alt="Star 4" className="w-full h-full" />
        </div>
        <div
          className="flex justify-center items-center p-2"
          onClick={(e) => {
            e.preventDefault();
            addPolygone(canvas, "star5");
          }}
        >
          <img src={Star5Img} alt="Star 5" className="w-full h-full" />
        </div>
        <div
          className="flex justify-center items-center p-2"
          onClick={(e) => {
            e.preventDefault();
            addLine(canvas);
            dispatch(setShapesDrawer(!visible));
          }}
        >
          <img src={LineImg} alt="Star 5" className="w-full h-full" />
        </div>
      </div>
    </Drawer>
  );
};

export default ShapesDrawer;
